export class relatedEntitiesRevisionTable {
    columns: string[];
    rows: Array<{ data: string[], relateObject: any}>;
    rowData?: Array<{ source: string, path: string}>;

    constructor() {
      this.columns = [];
      this.rows = [];
    }
  }
